export type AbsenceStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
export type HalfDayPart = 'AM' | 'PM';

export interface AbsenceType {
  id: string;
  code: string;
  name: string;
  color: string;
  consumesBalance: boolean;
  isActive: boolean;
}

export interface AbsenceRequestSummary {
  id: string;
  userId: string;
  absenceTypeId: string;
  startDate: string;
  endDate: string;
  isHalfDay: boolean;
  halfDayPart: HalfDayPart | null;
  /** Tramo "HH:mm" en las ausencias por horas (tipo JUSTIFIED_HOURS). */
  startTime: string | null;
  endTime: string | null;
  /** RR. HH. dio por bueno el justificante → no consume saldo. */
  isJustified: boolean;
  comment: string | null;
  status: AbsenceStatus;
  decidedAt: string | null;
  decisionNotes: string | null;
  createdAt: string;
  updatedAt: string;
  absenceType: AbsenceType;
  user?: { id: string; fullName: string; email: string };
}

export interface AbsenceBalance {
  absenceTypeId: string;
  code: string;
  name: string;
  color: string;
  consumesBalance: boolean;
  availableDays: number;
}

export const STATUS_LABEL: Record<AbsenceStatus, string> = {
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
  CANCELLED: 'Cancelada',
};

export type BadgeTone = 'neutral' | 'amber' | 'green' | 'red' | 'blue';

export const STATUS_TONE: Record<AbsenceStatus, BadgeTone> = {
  PENDING: 'amber',
  APPROVED: 'green',
  REJECTED: 'red',
  CANCELLED: 'neutral',
};
